import moment from 'moment';
import { isNil } from 'lodash';

export function getFinishedReportChips(report) {
  const reportGradeAvailable = !isNil(report.grade);
  const testSpentTime = getTestSpentTime(report);

  const defaultChips = [
    {
      icon: 'date_range',
      title: 'Started',
      text: moment(report.startDate).format('MM/DD/YYYY [at] hh:mm A'),
    },
    {
      icon: 'date_range',
      title: 'Finished',
      text: moment(report.finishDate).format('MM/DD/YYYY [at] hh:mm A'),
    },
    {
      icon: 'timer',
      title: 'Spent',
      text: testSpentTime,
    },
    {
      icon: 'hourglass_bottom',
      title: 'Time out',
      text: report.finishedManually ? 'Finished manually' : 'Finished due to time out',
    },
  ];

  if (reportGradeAvailable) {
    const successDataChips = [
      {
        icon: 'notes',
        title: 'Status',
        text: report.success ? 'Passed' : 'Failed',
      },
      {
        icon: 'grade',
        title: 'Grade',
        text: report.grade,
      },
    ];
    return successDataChips.concat(defaultChips);
  }
  return defaultChips;
}

function getTestSpentTime(report) {
  if (!report) {
    return null;
  }
  const format = 'HH:mm:ss';
  const durationStart = moment.utc().startOf('day');
  return durationStart.add(report.spentTime, 'ms').format(format);
}
